import { m } from 'motion/react';
import {
  containerVariants,
  itemVariantsNoY,
  viewPort,
} from '../../../utils/framer';

interface TwoFlexibleComponentBoxProps {
  firstComponent: React.ReactNode;
  secondComponent: React.ReactNode;
  mobilFirstComponentOnTop?: boolean;
  desktopFirstComponentFirst?: boolean;
  firstComponentWidth?: string;
  secondComponentWidth?: string;
  mainBoxClassName?: string;
  firstComponentClassName?: string;
  secondComponentClassName?: string;
  noGap?: boolean;
}

export const TwoFlexibleComponentBox: React.FC<
  TwoFlexibleComponentBoxProps
> = ({
  firstComponent,
  secondComponent,
  mobilFirstComponentOnTop = true,
  desktopFirstComponentFirst = true,
  firstComponentWidth = 'col-span-4',
  secondComponentWidth = 'col-span-4',
  mainBoxClassName = '',
  firstComponentClassName = '',
  secondComponentClassName = '',
  noGap = false,
}) => {
  return (
    <m.div
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className={`grid lg:grid-cols-8 w-full ${mainBoxClassName} ${!noGap && 'gap-y-4'}`}
    >
      <m.div
        variants={itemVariantsNoY}
        className={`${firstComponentWidth} ${firstComponentClassName} ${mobilFirstComponentOnTop ? 'order-1' : 'order-2'} ${
          desktopFirstComponentFirst ? 'lg:order-1' : 'lg:order-2'
        }`}
      >
        {firstComponent}
      </m.div>
      <m.div
        variants={itemVariantsNoY}
        className={`${secondComponentWidth} ${secondComponentClassName} ${mobilFirstComponentOnTop ? 'order-2' : 'order-1'} ${
          desktopFirstComponentFirst ? 'lg:order-2' : 'lg:order-1'
        }`}
      >
        {secondComponent}
      </m.div>
    </m.div>
  );
};
